module.exports = __webpack_public_path__ + "static/media/cog.ac7e70ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/cog.svg
// module id = 476
// module chunks = 0